export default __webpack_public_path__ + "static/media/lounge.6f0c494e.png";